import { BrandLogo } from "@components/data-display";
import { _MemberSettingOnboardDialogLayout } from "@types";
import { DrawerTitleClasses } from "kz-ui-sdk";
import { ReactNode, useCallback } from "react";
import { closeOnboardingDialog } from "../../../../utils/OnboardingDialog/utils";
import { OnboardLayoutProps } from "../../types/props";
import OnboardDialogDrawerLayout from "./components/OnboardDialogDrawerLayout/OnboardDialogDrawerLayout";
import OnboardDialogPageLayout from "./components/OnboardDialogPageLayout/OnboardDialogPageLayout";

interface OnboardingDialogLayoutProps extends Omit<OnboardLayoutProps, "title"> {
  layout: _MemberSettingOnboardDialogLayout;
  titleClasses?: DrawerTitleClasses["classes"];
  drawerTitle?: string;
  drawerSubTitle?: ReactNode;
  pageTitle?: ReactNode;
  pageSubTitle?: ReactNode;
}

const OnboardingDialogLayout = ({
  drawerTitle,
  drawerSubTitle,
  pageTitle,
  pageSubTitle,
  children,
  navigation = {},
  features,
  transitions,
  titleClasses,
  layout,
  variant,
}: OnboardingDialogLayoutProps) => {
  const handleOnClose = useCallback(() => {
    if (navigation.close?.onClick) navigation.close.onClick();
    else closeOnboardingDialog();
  }, [navigation.close]);

  /**
   * ONBOARDING DIALOG DRAWER LAYOUT
   */
  if (layout === _MemberSettingOnboardDialogLayout.DIALOG_DRAWER) {
    return (
      <OnboardDialogDrawerLayout
        title={drawerTitle || <BrandLogo className="mx-auto !h-6" />}
        subTitle={drawerSubTitle}
        features={{
          ...features,
          // Drawer always show close button and hide chat button
          showCloseButton: true,
          showChatButton: false,
        }}
        navigation={{
          close: {
            onClick: handleOnClose,
          },
          ...navigation,
        }}
        titleClasses={{
          ...titleClasses,
          "title&": "!text-xl",
        }}
      >
        {children}
      </OnboardDialogDrawerLayout>
    );
  }

  /**
   * ONBOARDING DIALOG PAGE LAYOUT
   */
  if (layout === _MemberSettingOnboardDialogLayout.DIALOG_PAGE) {
    return (
      <OnboardDialogPageLayout
        title={pageTitle}
        subTitle={pageSubTitle}
        navigation={{
          close: {
            onClick: handleOnClose,
          },
          ...navigation,
        }}
        features={features}
        variant={variant}
        transitions={transitions}
        contentClassName="animate-fade-in"
      >
        {children}
      </OnboardDialogPageLayout>
    );
  }
};

export default OnboardingDialogLayout;
